module.exports = __webpack_public_path__ + "img/car_00060.69daea53.jpg";